import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProXSignService {
  private scriptLoaded = false;
  public licenceUrl="https://www.setcce.si/proxsign/licenses/Borzen2025_lic1.lic";
  public licenceContent="##############################################################################################\n# license file for SETCCE proXSign PDF Component\n# Subscriber: Borzen d.o.o., (Integrator SEMANTIKA d.o.o.)\n# Components: PDF\n# Platform: Windows,Linux,Mac\n############################################################################################\nOwner=Borzen d.o.o.\nServer1=borzen.si\nComponent=proXSign PDF\nPlatform=Windows,Linux,Mac\nBrowser=Internet Explorer,Firefox,Chrome,Safari\nMaxVersion=3.0.0\nSignature=Br3/piBrT1ahvCk61qrIUutM+PzHjoD52dRYRnIpH6zxJrdgNyXQhGZn8g9gV8Tq554sXEL6omonKeRMh2nOtSYHrbxbxVpNFJnG6TjeYgab71USZWr8lSq8mGWynpj+c39JAFf8qvIHNnZCtN9trnwOXm+xJ0TVz38J3UrmlfU=";

  proXSignLib:any;

  loadScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'assets/libs/proXSign.min.js';
      script.type = 'text/javascript';
      script.async = true;
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = () => {
      console.log("Cant load lib.")
      reject(new Error('Failed to load proXSign.min.js'));
      };

      document.body.appendChild(script);
    });
  }

  isLibraryLoaded(): boolean {
    return typeof (window as any).proXSign !== 'undefined';
  }

  getLibrary(): any {
    this.proXSignLib = (window as any).proXSign;

    return this.proXSignLib;
  }

}
